import { UiSchema } from '@rjsf/utils'

import { FormProperties } from '../imup/types'
const uiSchema: UiSchema = {
    fixture_type: {
        'ui:title': 'Fixture Type',
        'ui:placeholder': 'Select Fixture Type',
    },
    showertub_type: {
        'ui:placeholder': 'Select Shower/Tub Type',
    },
    sink_type: {
        'ui:placeholder': 'Select Sink Type',
    },
    'ui:order': ['fixture_type', 'showertub_type', 'sink_type'],
}
const onValidate = () => {}

const onSubmit = (settings, formData) => {
    const newSettings = { ...settings, ...formData }

    if (newSettings.fixture_type !== 'SHOWER/TUB') {
        newSettings.showertub_type = null
    }
    if (newSettings.fixture_type !== 'SINK') {
        newSettings.sink_type = null
    }

    return newSettings
}
const form: FormProperties = { uiSchema, onValidate, onSubmit }

export default form
